import { Component } from '@angular/core';
import { translate } from '@shared-libs/helpers';
import { DeviceProvider } from '@internal-providers/device.provider';
import { MessageService } from '@shared-services/message.service';
import { IDevice } from '@internal-models/device.model';
import { remove } from 'lodash';
import { NavigationService } from '@shared-services/navigation.service';
import { Action } from '@shared-libs/enums';

@Component({
	selector: 'import-devices-component',
	templateUrl: 'import-devices.component.html',
	styleUrls: ['./import-devices.component.scss'],
})
export class ImportDevicesComponent {
	public devices: Array<IDevice>;
	public showPreview: Boolean = false;

	constructor(
		private readonly deviceProvider: DeviceProvider,
		private readonly messageService: MessageService,
		private readonly navigationService: NavigationService
	) {}

	public async downloadImportTemplate(): Promise<void> {
		await this.deviceProvider.getImportTemplate();
		this.messageService.showSavedMessage(translate('DEVICE.TEMPLATE_DOWNLOADED'));
	}

	public async uploadDevicesExcel(event: Event): Promise<void> {
		this.showPreview = false;
		const file: File = (event.target as HTMLInputElement).files?.[0];
		if (file) {
			const form = new FormData();
			form.append('excel', file, 'devices_import.xlsx');
			this.devices = await this.deviceProvider.getImportedDevices(form);

			this.showPreview = true;
		}
	}

	public removeDeviceFromImport(device: IDevice): void {
		remove(this.devices, device);
	}

	public async importDevices(): Promise<void> {
		await this.deviceProvider.import(this.devices);
		this.navigationService.navigateBack({ action: Action.CREATE });
	}
}
